export default __webpack_public_path__ + "static/media/ic_svg_error.67543287.svg";